/**
 * Product buy box: resolves the variant from the option chips, toggles between the
 * subscription and one-time purchase, recalculates prices, drives the per-variant
 * gallery, quantity stepper and nutrition dialog, and adds the selection (plus any
 * gift lines) to the cart or sends it straight to checkout.
 */
(function () {
  var scriptTag = document.currentScript;
  var sectionId = scriptTag && scriptTag.dataset ? scriptTag.dataset.id : null;
  if (!sectionId) return;

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    try {
      if (typeof price === 'function') return price(cents, true);
    } catch (e) { /* theme price helper failed; use the fallback below */ }
    var val = Math.round(cents) / 100;
    var str = val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
    return '$' + str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function parseMoneyText(text) {
    if (!text) return null;
    var m = String(text).replace(/,/g, '').match(/(\d+)(?:\.(\d{1,2}))?/);
    if (!m) return null;
    var dec = m[2] ? (m[2].length === 1 ? m[2] + '0' : m[2]) : '00';
    return parseInt(m[1], 10) * 100 + parseInt(dec, 10);
  }

  function setText(el, value) {
    if (el) el.textContent = value == null ? '' : String(value);
  }

  function fetchCart() {
    if (typeof getCart === 'function') return getCart();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js').then(function (r) { return r.json(); });
  }

  function clearCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/clear.js', { method: 'POST' }).then(function (r) { return r.json(); });
  }

  function postItems(formData) {
    if (typeof addProduct === 'function') return addProduct(formData);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    }).then(function (r) { return r.json(); });
  }

  function init(section) {
    var product = parseJSON(section.querySelector('[data-pdp-product]'));
    var cfg = parseJSON(section.querySelector('[data-pdp-config]')) || {};
    if (!product || !product.variants) return;

    var els = {
      optionGroups: section.querySelectorAll('[data-option-group]'),
      planCards: section.querySelectorAll('[data-plan]'),
      price: section.querySelector('[data-price]'),
      compare: section.querySelector('[data-compare]'),
      pill: section.querySelector('[data-pill]'),
      subCompare: section.querySelector('[data-sub-compare]'),
      subPrice: section.querySelector('[data-sub-price]'),
      otpPrice: section.querySelector('[data-otp-price]'),
      otpCompare: section.querySelector('[data-otp-compare]'),
      qtyInput: section.querySelector('[data-qty-input]'),
      qtyMinus: section.querySelector('[data-qty-minus]'),
      qtyPlus: section.querySelector('[data-qty-plus]'),
      atc: section.querySelector('[data-atc]'),
      atcLabel: section.querySelector('[data-atc-label]'),
      atcCompare: section.querySelector('[data-atc-compare]'),
      atcPrice: section.querySelector('[data-atc-price]'),
      error: section.querySelector('[data-error]'),
      galleries: section.querySelectorAll('[data-gallery]'),
      nutritionBtn: section.querySelector('[data-nutrition-open]'),
      dialog: section.querySelector('[data-nutrition-dialog]')
    };

    var basePlanId = cfg.planId ? String(cfg.planId) : '';
    // An affiliate offer can swap in its own plan (e.g. friends & family); otherwise the block's plan is used.
    var planId = basePlanId;
    // extra: percent an affiliate code takes off at checkout, set by the affiliate offer banner (0 elsewhere).
    var state = { variant: null, purchase: 'onetime', qty: 1, extra: { sub: 0, otp: 0, badgeTotal: false } };
    var swipers = {};

    /** Applies a code's percent the way checkout does: one rounding on the line total. */
    function withExtra(cents, percent) {
      return percent > 0 ? Math.round(cents * (100 - percent) / 100) : cents;
    }

    /** True when some variant of this product carries the plan in an allowed SKIO group. */
    function productHasPlan(id) {
      return product.variants.some(function (v) {
        return (v.selling_plan_allocations || []).some(function (a) {
          if (String(a.selling_plan_id) !== id) return false;
          return !(cfg.skioGroupIds && cfg.skioGroupIds.length && cfg.skioGroupIds.indexOf(a.selling_plan_group_id) === -1);
        });
      });
    }

    function setExtra(offer) {
      var offerPlan = offer && offer.planId ? String(offer.planId) : '';
      planId = offerPlan && productHasPlan(offerPlan) ? offerPlan : basePlanId;
      state.extra = {
        sub: offer ? Math.max(0, Math.min(90, Number(offer.subPercent) || 0)) : 0,
        otp: offer ? Math.max(0, Math.min(90, Number(offer.otpPercent) || 0)) : 0,
        badgeTotal: !!(offer && offer.badgeTotal)
      };
    }

    /* ── Data helpers ─────────────────────────────────────────────────── */
    /** Returns the variant's allocation for the configured selling plan, limited to the allowed SKIO plan groups. */
    function getAllocation(variant) {
      if (!variant || !planId || !variant.selling_plan_allocations) return null;
      for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
        var a = variant.selling_plan_allocations[i];
        if (String(a.selling_plan_id) !== planId) continue;
        if (cfg.skioGroupIds && cfg.skioGroupIds.length && cfg.skioGroupIds.indexOf(a.selling_plan_group_id) === -1) continue;
        return a;
      }
      return null;
    }

    function selectedOptions() {
      var values = [];
      els.optionGroups.forEach(function (group, i) {
        var checked = group.querySelector('[data-option-input]:checked');
        values[i] = checked ? checked.value : null;
      });
      return values;
    }

    function findVariant(values) {
      if (!values.length) return product.variants[0] || null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] != null && v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /** One-time, compare-at, first-order and recurring prices for a variant, plus the discount badge. */
    function computePrices(variant) {
      var otp = variant ? variant.price : 0;
      var compareAt = variant && variant.compare_at_price ? variant.compare_at_price : 0;
      var alloc = getAllocation(variant);
      var recurring = alloc ? alloc.price : otp;
      var firstOrder = null;
      var badge = cfg.firstOrderBadge || '';
      if (alloc && alloc.price_adjustments && alloc.price_adjustments.length === 2) {
        // A plan with two pricing policies discounts the first order ([0]) differently from renewals ([1]).
        firstOrder = alloc.price_adjustments[0].price;
        recurring = alloc.price_adjustments[1].price;
        if (otp > 0 && firstOrder < otp) badge = Math.round((otp - firstOrder) * 100 / otp) + '% OFF FIRST ORDER';
      }
      if (firstOrder == null) firstOrder = parseMoneyText(cfg.firstOrderText);
      if (firstOrder == null) firstOrder = recurring;
      return { otp: otp, compareAt: compareAt, recurring: recurring, firstOrder: firstOrder, badge: badge, hasPlan: !!alloc };
    }

    function isAvailable(variant) {
      if (!variant) return false;
      if (variant.available !== false) return true;
      // Variants that continue selling when out of stock, or are untracked, can still be bought.
      return (cfg.purchasableIds || []).indexOf(String(variant.id)) !== -1;
    }

    function isSubscription() {
      return state.purchase === 'subscription' && computePrices(state.variant).hasPlan;
    }

    /* ── Rendering ────────────────────────────────────────────────────── */
    function render() {
      var variant = state.variant;
      var p = computePrices(variant);
      var isSub = state.purchase === 'subscription' && p.hasPlan;
      var qty = state.qty;

      els.optionGroups.forEach(function (group) {
        var checked = group.querySelector('[data-option-input]:checked');
        var valueEl = group.querySelector('[data-option-value]');
        if (valueEl && checked) setText(valueEl, checked.value);
        group.querySelectorAll('[data-option-input]').forEach(function (input) {
          var chip = input.closest('.anomaly-pdp__chip');
          if (chip) chip.classList.toggle('is-selected', input.checked);
        });
      });

      var subUnit = withExtra(p.firstOrder, state.extra.sub);
      var otpUnit = withExtra(p.otp, state.extra.otp);
      var otpCompare = otpUnit < p.otp ? p.otp : (p.compareAt > p.otp ? p.compareAt : 0);
      // Where the page asks for it, the badge states the total saving with the code, not the plan's alone.
      var subBadge = p.badge;
      if (state.extra.badgeTotal && state.extra.sub > 0 && p.otp > 0 && subUnit < p.otp) {
        subBadge = Math.round((p.otp - subUnit) * 100 / p.otp) + '% OFF FIRST ORDER';
      }

      if (isSub) {
        setText(els.price, formatMoney(subUnit));
        setText(els.compare, formatMoney(p.otp));
        setText(els.pill, subBadge);
      } else {
        setText(els.price, formatMoney(otpUnit));
        setText(els.compare, otpCompare ? formatMoney(otpCompare) : '');
        setText(els.pill, '');
      }

      setText(els.subCompare, formatMoney(p.otp));
      setText(els.subPrice, formatMoney(subUnit));
      setText(els.otpPrice, formatMoney(otpUnit));
      setText(els.otpCompare, otpUnit < p.otp ? formatMoney(p.otp) : '');

      els.planCards.forEach(function (card) {
        var input = card.querySelector('[data-plan-input]');
        var isSubCard = card.dataset.plan === 'subscription';
        var disabled = isSubCard && !p.hasPlan;
        var selected = !disabled && card.dataset.plan === (isSub ? 'subscription' : 'onetime');
        if (input) {
          input.disabled = disabled;
          input.checked = selected;
        }
        card.classList.toggle('is-disabled', disabled);
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });

      if (els.atc) {
        var available = isAvailable(variant);
        var label = !variant ? cfg.unavailableText : (available ? cfg.atcText : cfg.soldOutText);
        els.atc.disabled = !available;
        setText(els.atcLabel, label || '');
        var lineTotal = isSub ? withExtra(p.firstOrder * qty, state.extra.sub) : withExtra(p.otp * qty, state.extra.otp);
        var compare = isSub ? p.otp : otpCompare;
        setText(els.atcPrice, variant ? formatMoney(lineTotal) : '');
        setText(els.atcCompare, variant && compare ? formatMoney(compare * qty) : '');
      }

      if (els.qtyInput) els.qtyInput.value = String(qty);
      if (els.qtyMinus) els.qtyMinus.setAttribute('aria-disabled', qty <= 1 ? 'true' : 'false');

      if (variant) {
        switchGallery(String(variant.id));
        updateNutrition(String(variant.id));
        // Keep ?variant= in the URL in step with the selection so the page can be shared or reloaded.
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        } catch (e) { /* URL API unavailable: skip the URL sync */ }
      }
    }

    /* ── Gallery ──────────────────────────────────────────────────────── */
    function scrollThumbIntoView(rail, thumb) {
      if (!rail || !thumb) return;
      var left = thumb.offsetLeft;
      var right = left + thumb.offsetWidth;
      if (left < rail.scrollLeft) rail.scrollTo({ left: left, behavior: 'smooth' });
      else if (right > rail.scrollLeft + rail.clientWidth) rail.scrollTo({ left: right - rail.clientWidth, behavior: 'smooth' });
    }

    function setActiveThumb(gallery, index) {
      var rail = gallery.querySelector('[data-thumbs]');
      gallery.querySelectorAll('[data-thumb]').forEach(function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
        thumb.setAttribute('tabindex', on ? '0' : '-1');
        if (on) scrollThumbIntoView(rail, thumb);
      });
    }

    function initGallery(gallery) {
      var id = gallery.dataset.variantId;
      if (swipers[id]) { swipers[id].update(); return; }
      var swiperEl = gallery.querySelector('[data-gallery-swiper]');
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      var slides = swiperEl ? swiperEl.querySelectorAll('.swiper-slide') : [];
      var current = 0;

      function goTo(index) {
        if (!slides.length) return;
        current = ((index % slides.length) + slides.length) % slides.length;
        if (swipers[id] && swipers[id] !== true) {
          if (swipers[id].params.loop) swipers[id].slideToLoop(current); else swipers[id].slideTo(current);
        } else {
          slides.forEach(function (slide, i) { slide.style.display = i === current ? '' : 'none'; });
          setActiveThumb(gallery, current);
        }
      }

      if (swiperEl && typeof Swiper !== 'undefined' && slides.length) {
        var sw = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 400,
          effect: 'fade',
          fadeEffect: { crossFade: true },
          loop: slides.length > 1,
          watchOverflow: true,
          navigation: {
            prevEl: gallery.querySelector('[data-gallery-prev]'),
            nextEl: gallery.querySelector('[data-gallery-next]')
          },
          on: {
            slideChange: function () { setActiveThumb(gallery, this.realIndex); }
          }
        });
        swipers[id] = sw;
      } else {
        swipers[id] = true;
        var prev = gallery.querySelector('[data-gallery-prev]');
        var next = gallery.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
        if (next) next.addEventListener('click', function () { goTo(current + 1); });
        goTo(0);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(parseInt(thumb.dataset.index, 10) || 0);
        });
        thumb.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var idx = (parseInt(thumb.dataset.index, 10) || 0) + (e.key === 'ArrowRight' ? 1 : -1);
          idx = ((idx % thumbs.length) + thumbs.length) % thumbs.length;
          goTo(idx);
          if (thumbs[idx]) thumbs[idx].focus();
        });
      });
    }

    function switchGallery(variantId) {
      els.galleries.forEach(function (gallery) {
        var on = gallery.dataset.variantId === variantId;
        gallery.classList.toggle('is-active', on);
        if (on) initGallery(gallery);
      });
    }

    /* ── Nutrition dialog ─────────────────────────────────────────────── */
    function updateNutrition(variantId) {
      if (!els.dialog) return;
      var images = els.dialog.querySelectorAll('[data-nutrition-image]');
      var match = null;
      var generic = null;
      images.forEach(function (img) {
        if (img.dataset.variantId === variantId) match = img;
        if (!img.dataset.variantId) generic = img;
      });
      var show = match || generic;
      images.forEach(function (img) { img.classList.toggle('is-active', img === show); });
      if (els.nutritionBtn) els.nutritionBtn.hidden = !show;
    }

    function initDialog() {
      var dialog = els.dialog;
      var openBtn = els.nutritionBtn;
      if (!dialog || !openBtn || typeof dialog.showModal !== 'function') return;
      var closeBtn = dialog.querySelector('[data-nutrition-close]');

      openBtn.addEventListener('click', function () {
        dialog.showModal();
        document.body.classList.add('noScroll');
      });
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        document.body.classList.remove('noScroll');
      });
    }

    /* ── Add to cart ──────────────────────────────────────────────────── */
    function setLoading(on) {
      if (!els.atc) return;
      els.atc.classList.toggle('is-loading', on);
      els.atc.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function showError(message) {
      setText(els.error, message || '');
    }

    /* Direct checkout: the cart is cleared before adding, so checkout holds only this selection and its gifts.
       Cart permalinks are not used because they do not support selling plans. The button stays in its loading
       state until the page unloads. */
    function goToCheckout() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root + 'checkout';
    }

    /**
     * Adds the selected variant (with its selling plan when subscribing) and any eligible gift lines.
     * Gifts are tagged with `_gift_for` so they are added only once per variant. On success it opens
     * the cart drawer, falling back to /cart, or goes to checkout when direct checkout is enabled.
     */
    function addToCart() {
      var variant = state.variant;
      if (!variant || !isAvailable(variant)) return Promise.resolve();
      var p = computePrices(variant);
      var isSub = state.purchase === 'subscription' && p.hasPlan;
      var planNum = parseInt(planId, 10) || null;
      var qty = state.qty;

      setLoading(true);
      showError('');

      var gifts = (cfg.gifts || []).filter(function (gift) {
        return parseInt(gift.id, 10) && (isSub || !gift.subOnly);
      });

      var giftCheck = gifts.length && !cfg.directCheckout /* a cleared cart cannot already hold the gift */
        ? fetchCart().then(function (cart) {
            return (cart.items || []).some(function (item) {
              return item.properties && item.properties._gift && String(item.properties._gift_for) === String(variant.id);
            });
          }).catch(function () { return false; })
        : Promise.resolve(false);

      return giftCheck.then(function (ownerHasGifts) {
        var items = [];
        if (!ownerHasGifts) {
          gifts.forEach(function (gift) {
            items.push({ id: parseInt(gift.id, 10), quantity: 1, properties: { _gift: true, _gift_for: String(variant.id) } });
          });
        }
        if (isSub && planNum) {
          items.push({ id: variant.id, quantity: qty, selling_plan: planNum, properties: { _selling_plan_offer: planNum } });
        } else {
          items.push({ id: variant.id, quantity: qty, selling_plan: null, properties: {} });
        }
        if (cfg.directCheckout) return clearCart().then(function () { return postItems({ items: items }); });
        return postItems({ items: items });
      }).then(function (res) {
        if (res && res.status && res.status >= 400) {
          throw new Error(res.description || res.message || 'Could not add to cart.');
        }
        if (cfg.directCheckout) return goToCheckout();
        setLoading(false);
        if (typeof openCart === 'function') return openCart();
        window.location.href = '/cart';
      }).catch(function (err) {
        setLoading(false);
        showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
      });
    }

    /* ── Events ───────────────────────────────────────────────────────── */
    section.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        state.variant = findVariant(selectedOptions());
        render();
      });
    });

    els.planCards.forEach(function (card) {
      var input = card.querySelector('[data-plan-input]');
      if (!input) return;
      input.addEventListener('change', function () {
        if (input.checked) { state.purchase = input.value; render(); }
      });
      card.addEventListener('click', function (e) {
        if (card.classList.contains('is-disabled')) return;
        if (e.target.closest('a, button')) return;
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    function setQty(next) {
      next = parseInt(next, 10);
      if (isNaN(next) || next < 1) next = 1;
      if (next > 99) next = 99;
      state.qty = next;
      render();
    }
    if (els.qtyMinus) els.qtyMinus.addEventListener('click', function () { setQty(state.qty - 1); });
    if (els.qtyPlus) els.qtyPlus.addEventListener('click', function () { setQty(state.qty + 1); });
    if (els.qtyInput) {
      els.qtyInput.addEventListener('change', function () { setQty(els.qtyInput.value); });
      els.qtyInput.addEventListener('input', function () {
        var v = parseInt(els.qtyInput.value, 10);
        if (!isNaN(v) && v >= 1) { state.qty = Math.min(v, 99); render(); }
      });
    }

    if (els.atc) els.atc.addEventListener('click', function () { addToCart(); });

    initDialog();

    /* ── Initial state ────────────────────────────────────────────────── */
    /* On page templates Liquid cannot pre-select ?variant=, so check the matching option chips here.
       On product pages they are already checked server-side. */
    try {
      var urlVariantId = new URL(window.location.href).searchParams.get('variant');
      if (urlVariantId) {
        var urlVariant = product.variants.filter(function (v) { return String(v.id) === String(urlVariantId); })[0];
        if (urlVariant) {
          els.optionGroups.forEach(function (group, i) {
            var inputs = group.querySelectorAll('[data-option-input]');
            for (var k = 0; k < inputs.length; k++) {
              if (inputs[k].value === urlVariant.options[i]) { inputs[k].checked = true; break; }
            }
          });
        }
      }
    } catch (e) { /* URL API unavailable: keep the server-rendered selection */ }
    var initialVariant = findVariant(selectedOptions());
    if (!initialVariant && cfg.activeVariantId) {
      initialVariant = product.variants.filter(function (v) { return String(v.id) === String(cfg.activeVariantId); })[0] || null;
    }
    state.variant = initialVariant;
    var checkedPlan = section.querySelector('[data-plan-input]:checked');
    state.purchase = checkedPlan ? checkedPlan.value : 'onetime';
    if (els.qtyInput) state.qty = Math.max(1, parseInt(els.qtyInput.value, 10) || 1);
    setExtra(window.anomalyAffiliateOffer);
    document.addEventListener('anomaly:affiliate-offer', function (e) {
      setExtra(e.detail);
      render();
    });
    render();
  }

  function boot() {
    var section = document.getElementById(sectionId);
    if (section && section.dataset.pdpReady !== 'true') {
      section.dataset.pdpReady = 'true';
      init(section);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-initialise when the theme editor re-renders this section.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === sectionId) boot();
  });
})();
